import {Indicator, Popover} from '@mantine/core';
import type {FC, ReactNode} from 'react';
import {MdClose} from 'react-icons/md';
import {Z_INDEX_BELOW_FIXED_HEADER} from '../../../../config/constants/zIndex';
import {cn} from '../../../../lib/classname';

type NotificationBadgeProps = {
  count: number;
  message?: string;
  children: ReactNode;
  opened: boolean;
  color?: string;
  onClose: () => void;
  offset?: number;
  messageClassName?: string;
  position?:
    | 'bottom'
    | 'bottom-end'
    | 'bottom-start'
    | 'top'
    | 'top-end'
    | 'top-start';
};

export const NotificationBadge: FC<NotificationBadgeProps> = ({
  count,
  message,
  children,
  opened,
  color = 'red',
  onClose,
  offset,
  messageClassName,
  position = 'bottom-end',
}) => {
  const displayMessage = message || `${count}件の通知があります`;

  if (count <= 0) {
    return <>{children}</>;
  }

  return (
    <Popover
      opened={opened}
      width="max-content"
      position={position}
      withArrow
      shadow="md"
      offset={offset}
      zIndex={Z_INDEX_BELOW_FIXED_HEADER}
    >
      <Popover.Target>
        <Indicator
          color={color}
          withBorder
          inline
          zIndex={Z_INDEX_BELOW_FIXED_HEADER}
        >
          <span>{children}</span>
        </Indicator>
      </Popover.Target>
      <Popover.Dropdown>
        <div className="flex items-center justify-between gap-8">
          <div className={cn('text-xs', messageClassName)}>
            {displayMessage}
          </div>
          <button
            type="button"
            onClick={onClose}
            className="cursor-pointer bg-transparent border-none p-0 hover:opacity-70 transition-opacity"
            aria-label="通知を閉じる"
          >
            <MdClose size={18} />
          </button>
        </div>
      </Popover.Dropdown>
    </Popover>
  );
};
